export default "https://dakcheck.solease.nl/static/media/checkedData.71fa56ca.svg";